<template>
  <div class="icp-beian">
    <a
      href="https://beian.miit.gov.cn/"
      target="_blank"
      rel="noopener noreferrer"
    >蜀ICP备2025150450号</a>
  </div>
</template>

<script>
export default {
  name: 'IcpBeian',
}
</script>

<style scoped lang="scss">
.icp-beian {
  text-align: center;
  font-size: 12px;
  line-height: 1.5;

  a {
    color: #999999;
    text-decoration: none;

    &:hover {
      color: #2683be;
      text-decoration: underline;
    }
  }
}
</style>
